import { render, staticRenderFns } from "./AddVideoORZip.vue?vue&type=template&id=ba3e0c30&scoped=true"
import script from "./AddVideoORZip.vue?vue&type=script&lang=js"
export * from "./AddVideoORZip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3e0c30",
  null
  
)

export default component.exports